import React, { Component } from "react"
import fetch from "cross-fetch"
import queryString from "query-string"

import { addCookieData } from "../../helpers/handleCookies"

const postscribe = typeof window !== "undefined" ? require("postscribe") : null

class ChatBot extends Component {
  async componentDidMount() {
    const { botId } = this.props.blok
    const cookies = addCookieData()

    const query = queryString.parse(window.location.search)
    const { S } = query

    let data = cookies

    if (!S) {
      const userLocation = await this.fetchUserLocation()
      data = {
        ...cookies,
        country_code: userLocation ? userLocation.country_code : "",
      }
    }

    if (postscribe) {
      postscribe(
        "#botCopyRef",
        `
    <script
  type="text/javascript"
  id="botcopy-embedder-d7lcfheammjct"
  class="botcopy-embedder-d7lcfheammjct"
  data-botId="${botId}"
  data-snippetRef='${JSON.stringify(data)}'
  >
  var s = document.createElement('script');
  s.type = 'text/javascript'; s.async = true;
  s.src = 'https://widget.botcopy.com/js/injection.js';
  document.getElementById('botcopy-embedder-d7lcfheammjct').appendChild(s);
</script>`
      )
    }
  }

  fetchUserLocation = () => {
    return fetch(`${process.env.GATSBY_IP_STACK}`)
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then((result) => {
        return result
      })
      .catch((err) => {
        console.error(err)
        return 'Not found'
      })
  }

  render() {
    return <div id="botCopyRef" />
  }
}

ChatBot.propTypes = {}

export default ChatBot
